import { Link } from 'react-router-dom';
import { GUIDES } from '../data/guides';
import { useJsonLd, SITE } from '../utils/seo';

const INK = '#0f172a';
const MUTED = '#64748b';
const INDIGO = '#6366f1';

// Categories in first-seen order.
const CATEGORIES = GUIDES.reduce((acc, g) => (acc.includes(g.category) ? acc : [...acc, g.category]), []);

function Guides() {
  useJsonLd('guides-index', {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'LE Tech Tools guides',
    itemListElement: GUIDES.map((g, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: g.title,
      url: `${SITE}/guides/${g.slug}`,
    })),
  });

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', color: INK, fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
      <div style={{ background: '#fff', borderBottom: '1px solid #e2e8f0' }}>
        <nav style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', maxWidth: 1100, margin: '0 auto', padding: '18px 32px' }}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none', fontWeight: 800, fontSize: 16, color: INK }}>
            <span style={{ display: 'inline-flex', width: 26, height: 26, borderRadius: 7, background: `linear-gradient(135deg, ${INDIGO}, #a855f7)`, alignItems: 'center', justifyContent: 'center' }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
            </span>
            LE Tech Tools
          </Link>
          <Link to="/tools" style={{ color: INDIGO, textDecoration: 'none', fontSize: 14, fontWeight: 600 }}>All tools →</Link>
        </nav>
      </div>

      <main style={{ maxWidth: 1100, margin: '0 auto', padding: '44px 32px 72px' }}>
        <h1 style={{ fontSize: 'clamp(28px, 4.5vw, 42px)', fontWeight: 800, letterSpacing: '-0.6px', margin: '0 0 12px' }}>
          Tool guides
        </h1>
        <p style={{ fontSize: 17, color: MUTED, lineHeight: 1.6, maxWidth: 620, margin: '0 0 40px' }}>
          A quick look at how each tool works and what it does — most run entirely in your browser, with online tools clearly labeled.
        </p>

        {CATEGORIES.map(cat => (
          <section key={cat} style={{ marginBottom: 40 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
              <h2 style={{ fontSize: 12, fontWeight: 700, letterSpacing: '.06em', textTransform: 'uppercase', color: MUTED, margin: 0 }}>{cat}</h2>
              <div style={{ flex: 1, height: 1, background: '#e2e8f0' }} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
              {GUIDES.filter(g => g.category === cat).map(g => (
                <Link key={g.slug} to={`/guides/${g.slug}`} style={{
                  display: 'flex', flexDirection: 'column', gap: 8, background: '#fff', border: '1px solid #e2e8f0',
                  borderRadius: 12, padding: '20px', textDecoration: 'none', boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                }}>
                  <h3 style={{ fontSize: 16, fontWeight: 700, color: INK, margin: 0 }}>{g.title}</h3>
                  <p style={{ fontSize: 13.5, color: MUTED, lineHeight: 1.6, margin: 0, flex: 1 }}>{g.tagline}</p>
                  <span style={{ fontSize: 13, fontWeight: 600, color: INDIGO }}>How it works →</span>
                </Link>
              ))}
            </div>
          </section>
        ))}
      </main>
    </div>
  );
}

export default Guides;
